import * as Yup from 'yup';
import { isEmailValid } from '@modernhealth/validations';

// Hook Yup's .email() schema validator into our own validation.
Yup.addMethod(Yup.string, 'email', function validateEmail(this: Yup.StringSchema, message) {
    return this.test('email', message, isEmailValid);
});
